import './bootstrap';
import {Navigation, Pagination} from 'swiper/modules';
import Swiper from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import {CustomConfirm} from "@/admin/functions/customConfirm.js";
import {createApp} from "vue";
import profileDashboard from "@/vue/profile/profileDashboard.vue";
import Reservation from "@/vue/admin/Historique/Reservation.vue";
import ProfileForm from "@/vue/profile/ProfileForm.vue";
import NoteForm from "@/vue/note/NoteForm.vue";
import BookDetail from "@/vue/DetailBook/BookDetail.vue";
import DocumentViewer from "@/vue/lecteur/DocumentViewer.vue";
import EpubViewer from "@/vue/lecteur/EpubViewer.vue";
import Events from "@/vue/Public/Events.vue";
import EventDetailPage from "@/vue/Public/event/detail/EventDetailPage.vue";
import {notifyUser} from "@/helper.js";
import {DatePicker} from "@/admin/Component/DatePicker.js";
import Search from "@/vue/search/Search.vue";
import {SelectInput} from "@/admin/Component/slimSelect.js";
import {FileDrop} from "@/admin/Component/fileDrop.js";
import BookCollection from "@/vue/collection/BookCollection.vue";
import ShowCollection from "@/vue/collection/ShowCollection.vue";
import LibraryResources from "@/vue/resources/LibraryResources.vue";
import Author from "@/vue/author/author.vue";
import Authors from "@/vue/author/Authors.vue";
import FirstConnect from "@/vue/firstConnect/FirstConnect.vue";
import categorie from "@/vue/categorie/categorie.vue";
import BookSlider from "@/vue/bookSlider/BookSlider.vue";
import NavSearch from "@/vue/admin/navbarSearch/NavSearch.vue";
import {BookCover} from "@/component/BookCover.js";


customElements.define("date-picker", DatePicker, {extends: "input"})
customElements.define("custom-select", SelectInput, {extends: "select"})
customElements.define("file-upload", FileDrop, {extends: "input"})
customElements.define('book-cover',BookCover)









/// user menu
const userMenuButton = document.getElementById('userMenuButton');
const userMenu = document.getElementById('userMenu');
const dropdownWrapper = document.getElementById('dropdownWrapper');

function openMenu() {
    userMenu.classList.remove('opacity-0', 'scale-95', 'pointer-events-none');
    userMenu.classList.add('opacity-100', 'scale-100', 'pointer-events-auto');
}

function closeMenu() {
    userMenu.classList.remove('opacity-100', 'scale-100', 'pointer-events-auto');
    userMenu.classList.add('opacity-0', 'scale-95', 'pointer-events-none');
}

if (userMenuButton) {
    userMenuButton.addEventListener('click', (e) => {
        e.stopPropagation();
        if (userMenu.classList.contains('opacity-0')) {
            openMenu();
        } else {
            closeMenu();
        }
    });

// Fermer si clic en dehors
    document.addEventListener('click', (e) => {
        if (!dropdownWrapper.contains(e.target)) {
            closeMenu();
        }
    });
}
notifyUser()
if (document.getElementById("app-profile")) {
    const app = createApp({});
    app.component("profileDashboard", profileDashboard);
    app.component("Reservation", Reservation);
    app.component("ProfileForm", ProfileForm);
    app.component("NoteForm", NoteForm);
    app.mount("#app-profile");
}

if (document.getElementById("events")) {
    const app = createApp({});
    app.component("Events", Events);
    app.component("EventDetailPage", EventDetailPage);
    app.mount("#events");
}

if (document.getElementById("book-swipper")) {
    const app = createApp({});
    app.component("BookSlider", BookSlider);
    app.mount("#book-swipper");
}

if (document.getElementById("lecture")) {
    const app = createApp({});
    app.component("DocumentViewer", DocumentViewer);
    app.component("EpubViewer", EpubViewer);
    app.mount("#lecture");
}

if (document.getElementById("app-detail")) {
    const app = createApp({});
    app.component("BookDetail", BookDetail);
    app.mount("#app-detail");
}



if (document.getElementById("app-collection")) {
    const app = createApp({});
    app.component("BookCollection", BookCollection);
    app.component("ShowCollection", ShowCollection);
    app.mount("#app-collection");
}

if (document.getElementById("app-resource")) {
    const app = createApp({});
    app.component("LibraryResources", LibraryResources);
    app.mount("#app-resource");
}

if (document.getElementById("app-author")) {
    const app = createApp({});
    app.component("Author", Author);
    app.component("Authors", Authors);
    app.mount("#app-author");
}

if (document.getElementById("app-categorie")) {
    const app = createApp({});
    app.component("categorie", categorie);
    app.mount("#app-categorie");
}


if (document.getElementById("first_connect")) {
    const app = createApp({});
    app.component("FirstConnect", FirstConnect);
    app.mount("#first_connect");
}


const getHeightSize = (menuBtn, megaMenu) => {
    const rect = menuBtn.getBoundingClientRect();
    megaMenu.style.top = `${rect.bottom}px`; // positionner sous le bouton
}


// Initialize Swiper
const swiper = new Swiper('.main-swiper', {
    // Optional parameters
    modules: [Navigation, Pagination], direction: 'horizontal', loop: true,

    navigation: {
        nextEl: '#next', prevEl: '#prev',
    }, pagination: {
        el: '.swiper-pagination', clickable: true, dynamicBullets: true,
    },

});

// Swiper des catégories
const thumbSwiper = new Swiper('.thumb-swiper', {
    modules: [Pagination], slidesPerView: 4, spaceBetween: 20, pagination: {
        el: '.thumb-swiper-pagination', clickable: true,
    },
});
const eventSwiper = new Swiper('.event-swiper', {
    modules: [Navigation], loop: true, spaceBetween: 16, direction: 'horizontal', navigation: {
        nextEl: '#next', prevEl: '#prev',
    }, breakpoints: {
        0: {
            slidesPerView: 1,
        }, 640: {
            slidesPerView: 2,
        }, 768: {
            slidesPerView: 3,
        },
    },
});

const megaMenuTrigger = () => {
    const trigger = document.querySelectorAll('#menu-trigger')
    if (trigger) {
        trigger.forEach((item) => {
            let megaMenu = item.querySelector('#mega-menu')
            if (megaMenu) {
                getHeightSize(item, megaMenu)
            }
        })
    }
}
megaMenuTrigger()
window.addEventListener('resize', () => {
    megaMenuTrigger()
});

const menuBtn = document.getElementById("menu-button");
if (menuBtn) {
    const megaMenu = document.querySelector("#mega-menu-explore");

    let isOpen = false;
    const openMenu = () => {
        megaMenu.classList.remove("invisible", "opacity-0", "pointer-events-none");
        isOpen = true;
    };

    const closeMenu = () => {
        megaMenu.classList.add("invisible", "opacity-0", "pointer-events-none");
        isOpen = false;
    };

    menuBtn.addEventListener("click", (e) => {
        e.stopPropagation();
        isOpen ? closeMenu() : openMenu();
    });

    // Clic en dehors = fermer
    document.addEventListener("click", (e) => {
        if (isOpen && !megaMenu.contains(e.target) && e.target !== menuBtn) {
            closeMenu();
        }
    });
}

const dynamicRadio = document.getElementById("dynamic-radio");
if (dynamicRadio) {
    let radioBtns = dynamicRadio.querySelectorAll('label input[type="radio"]');
    document.querySelector(`#${radioBtns[0].value}-tab`).classList.add('active')
    radioBtns.forEach((item) => {
        item.addEventListener('change', () => {
            radioBtns.forEach((btn) => {
                let tab = document.querySelector(`#${btn.value}-tab`);
                if (tab) tab.classList.remove('active');
            });

            let currentTab = document.querySelector(`#${item.value}-tab`);
            if (currentTab) currentTab.classList.add('active');
        });
    });
}

// auteur tab
document.addEventListener('DOMContentLoaded', function () {
    const tabs = document.querySelectorAll('nav a[href="#"]');

    tabs.forEach(tab => {
        tab.addEventListener('click', function (e) {
            e.preventDefault();
            const currentTab = this.dataset.id;

            // Cacher tous les contenus
            tabs.forEach(t => {
                const contentId = t.dataset.id;
                const content = document.getElementById(contentId);
                if (content) content.classList.add('hidden');

                // Réinitialiser le style des onglets
                t.classList.remove('text-red-700', 'border-red-700');
                t.classList.add('text-gray-600', 'border-transparent');
            });

            // Afficher le bon contenu
            const activeContent = document.getElementById(currentTab);
            if (activeContent) activeContent.classList.remove('hidden');

            // Appliquer les styles actifs à l’onglet
            this.classList.remove('text-gray-600', 'border-transparent');
            this.classList.add('text-red-700', 'border-red-700');
        });
    });
});

let confirmation = document.querySelector('#confirmation')
if (confirmation) {
    confirmation.addEventListener('click', (e) => {
        e.preventDefault()
        let form = confirmation.parentElement
        CustomConfirm(form, "Voulez-vous vraiment valider cet enregistrement ? <br> Ce processus ne peut pas être annulé.", 'Confirmer', 'btn__confirm')
    })
}

//profile
// Navigation entre les onglets
function initTabNavigation() {




    const openBtn = document.getElementById('openLoginModal');
    const closeBtn = document.getElementById('closeLoginModal');
    const modal = document.getElementById('loginModal');
    const passwordInput = document.getElementById('passwordInput');
    const togglePassword = document.getElementById('togglePassword');
    const eyeOpen = document.getElementById('eyeOpen');
    const eyeClosed = document.getElementById('eyeClosed');

    if (openBtn) {
        // Ouvrir le modal
        openBtn.addEventListener('click', () => {
            modal.classList.remove('hidden');
            setTimeout(() => modal.classList.add('opacity-100'), 10);
        });

        // Fermer le modal
        closeBtn.addEventListener('click', () => {
            modal.classList.add('hidden');
            modal.classList.remove('opacity-100');
        });

        // Fermer en cliquant sur le fond noir
        modal.addEventListener('click', (e) => {
            if (e.target === modal) {
                modal.classList.add('hidden');
                modal.classList.remove('opacity-100');
            }
        });

        // Afficher / masquer mot de passe
        togglePassword.addEventListener('click', () => {
            const isHidden = passwordInput.type === 'password';
            passwordInput.type = isHidden ? 'text' : 'password';
            eyeOpen.classList.toggle('hidden', !isHidden);
            eyeClosed.classList.toggle('hidden', isHidden);
        });
    }





    // js confirm
    let formDelete = document.querySelector('#form-delete')
    if (formDelete) {
        formDelete.addEventListener('submit', (e) => {
            e.preventDefault()
            CustomConfirm(formDelete, formDelete.dataset?.content ?? 'Voulez-vous vraiment continuer ? <br> Ce processus ne peut pas être annulé.', formDelete.dataset?.btn ?? 'Confirmer', formDelete.dataset?.method ?? 'post')
        })
    }


    const tabButtons = document.querySelectorAll('.tab-button');
    const tabContents = document.querySelectorAll('.tab-content');

    // Classes pour les états des onglets
    const activeTabClasses = 'text-orange-500 border-orange-500 bg-orange-50';
    const inactiveTabClasses = 'border-transparent bg-gray-100 text-gray-600 hover:text-orange-600';

    function showTab(tabName) {
        // Masquer tous les contenus
        tabContents.forEach(content => {
            content.classList.add('hidden');
        });

        // Afficher le contenu de l'onglet sélectionné
        const targetContent = document.getElementById(tabName + '-content');
        if (targetContent) {
            targetContent.classList.remove('hidden');
        }

        // Mettre à jour les styles des boutons
        tabButtons.forEach(button => {
            button.className = button.className
                .replace(activeTabClasses, '')
                .replace(inactiveTabClasses, '') + ' ' + inactiveTabClasses;
        });

        // Activer le bouton de l'onglet sélectionné
        const activeButton = document.getElementById(tabName + '-tab');
        if (activeButton) {
            activeButton.className = activeButton.className
                .replace(inactiveTabClasses, '') + ' ' + activeTabClasses;
        }
    }


    tabButtons.forEach(button => {
        button.addEventListener('click', () => {
            const tabName = button.getAttribute('data-tab');
            showTab(tabName);
        });
    });

    document.addEventListener('click', (e) => {
        if (e.target.matches('.next-tab-btn') || e.target.closest('.next-tab-btn')) {
            const button = e.target.matches('.next-tab-btn') ? e.target : e.target.closest('.next-tab-btn');
            const nextTab = button.getAttribute('data-next-tab');
            if (nextTab) showTab(nextTab);
        }

        if (e.target.matches('.prev-tab-btn') || e.target.closest('.prev-tab-btn')) {
            const button = e.target.matches('.prev-tab-btn') ? e.target : e.target.closest('.prev-tab-btn');
            const prevTab = button.getAttribute('data-prev-tab');
            if (prevTab) showTab(prevTab);
        }
    });

}
if (document.getElementById("app-search")) {
    const app = createApp({});
    app.component("Search", Search);
    app.mount("#app-search");
}
document.addEventListener('DOMContentLoaded', initTabNavigation);




